import { FORME_SLOT_REF } from './onglet.js';
import { ErreurPortail } from './transport.js';
/** Le nom du canal — borné à l'origine par le navigateur lui-même. */
export const NOM_CANAL = 'betool.identite';
const TYPES_AVEC_SLOT = new Set([
    'slot-utilise',
    'slot-retire',
    'session-revoquee',
    'identite-modifiee',
]);
const TYPES_SANS_SLOT = new Set([
    'slot-ajoute',
    'defaut-change',
    'trousseau-invalide',
]);
/**
 * La charge qui partira sur le fil : RECONSTRUITE, pas recopiée. Un appelant
 * qui aurait glissé plus que son type (profil, nom, courriel…) n'y gagne rien :
 * seuls `type` et l'éventuel `slotRef` traversent.
 */
function chargeDe(message) {
    const type = message.type;
    if (TYPES_AVEC_SLOT.has(type)) {
        const slotRef = message.slotRef;
        if (typeof slotRef !== 'string' || !FORME_SLOT_REF.test(slotRef)) {
            throw new ErreurPortail(0, 'charge_invalide', `Le signal ${type} exige un slotRef bien formé.`);
        }
        return { type, slotRef };
    }
    if (TYPES_SANS_SLOT.has(type))
        return { type };
    throw new ErreurPortail(0, 'message_inconnu', `Signal inconnu : ${String(type)}.`);
}
/**
 * Valide une charge venue du fil. Retourne null pour TOUT écart — type
 * inconnu, slot manquant ou déformé, slot sur un type qui n'en attend pas,
 * champ en trop : le canal est lisible par n'importe quel script de
 * l'origine, on ne lui accorde que la forme exacte.
 */
export function messageDeCharge(charge) {
    if (charge === null || typeof charge !== 'object')
        return null;
    const cles = Object.keys(charge).sort();
    const { type, slotRef } = charge;
    if (typeof type !== 'string')
        return null;
    if (TYPES_SANS_SLOT.has(type)) {
        return cles.length === 1 ? { type } : null;
    }
    if (TYPES_AVEC_SLOT.has(type)) {
        if (cles.length !== 2)
            return null;
        if (typeof slotRef !== 'string' || !FORME_SLOT_REF.test(slotRef))
            return null;
        return { type, slotRef };
    }
    return null;
}
/**
 * Crée le canal. Sans bus injecté, `BroadcastChannel` — s'il n'existe pas
 * ici, refus net (`canal_indisponible`) : c'est au runtime de décider alors
 * de vivre sans propagation, pas au canal de simuler.
 */
export function creerCanal(bus) {
    let busActif = bus;
    if (busActif === undefined) {
        if (typeof globalThis.BroadcastChannel !== 'function') {
            throw new ErreurPortail(0, 'canal_indisponible', 'BroadcastChannel est indisponible ici.');
        }
        const reel = new BroadcastChannel(NOM_CANAL);
        reel.unref?.();
        busActif = reel;
    }
    const busFinal = busActif;
    const auditeurs = new Set();
    const pont = (evenement) => {
        const message = messageDeCharge(evenement.data);
        if (message === null)
            return;
        for (const auditeur of auditeurs) {
            // Un auditeur qui jette est un défaut du CONSOMMATEUR : il ne doit
            // casser ni les autres auditeurs, ni le fil — on le rapporte, on continue.
            try {
                auditeur(message);
            }
            catch (erreur) {
                console.error('[identity-runtime] un auditeur du canal a échoué', erreur);
            }
        }
    };
    busFinal.addEventListener('message', pont);
    return {
        emettre(message) {
            busFinal.postMessage(chargeDe(message));
        },
        ecouter(auditeur) {
            auditeurs.add(auditeur);
            return () => void auditeurs.delete(auditeur);
        },
        fermer() {
            busFinal.removeEventListener('message', pont);
            auditeurs.clear();
            busFinal.close();
        },
    };
}
//# sourceMappingURL=canal.js.map